import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'i18next';

import DonutChart from 'common/charts/GoogleCharts/DonutChart';
import { FlexContainer } from 'common/components/atoms';
import LoadingSvg from 'common/images/LoadingSvg';
import { getDevicesResourceName } from '../../constants/adminDashboard.i18n';
import { getAccountAnalyticsMetadata } from '../constants/accountAnalytics.constants';

const ChartContainer = styled.div`
  background-color: white;
  height: 220px;
  border-radius: 4px;
`;

// Maps the raw legend labels produced by accountAnalytics.actions.js to their translation keys.
const CHART_LEGEND_LABEL_KEYS = {
  'Active Mote': 'accountAnalytics.charts.legend.activeMote',
  'Active Tx': 'accountAnalytics.charts.legend.activeTx',
  'Available Mote': 'accountAnalytics.charts.legend.availableMote',
  'Available Tx': 'accountAnalytics.charts.legend.availableTx',
  Active: 'accountAnalytics.charts.legend.active',
  Inactive: 'accountAnalytics.charts.legend.inactive',
};

const translateChartData = (data, t) => data.map((entry) => {
  const legendKey = CHART_LEGEND_LABEL_KEYS[entry.label];
  return legendKey ? { ...entry, label: t(legendKey, { defaultValue: entry.label }) } : entry;
});

const AccountAnalyticsWidget = (props) => {
  const accountAnalyticsState = props.accountAnalytics;
  const rawData = accountAnalyticsState[props.analytics_type];
  const data = rawData ? translateChartData(rawData, props.t) : rawData;
  const metadata = getAccountAnalyticsMetadata(props.t)[props.analytics_type];

  if (!data || accountAnalyticsState.loading) {
    return (
      <>
        <ChartContainer>
          <FlexContainer alignItems="center" justifyContent="center" height="100%">
            <LoadingSvg />
          </FlexContainer>
        </ChartContainer>
      </>
    );
  }
  if (data.error) {
    return (
    <>
      <div>{i18n.t('common.errors.errorLoadingAccountAnalytics', { defaultValue: 'Error loading Account Analytics' })}</div>
    </>
    );
  }
  return (
    <ChartContainer>
      <DonutChart
        title={metadata.title}
        data={data}
        resourceName={getDevicesResourceName()}
        colors={metadata.colors}
        formatData
        {...props}
      />
    </ChartContainer>
  );
};

const mapStateToProps = state => ({
  adminDashboard: state.adminDashboard,
  accountAnalytics: state.accountAnalytics,
});

AccountAnalyticsWidget.propTypes = {
  first: PropTypes.bool,
  titlePaddingBottom: PropTypes.string,
  analytics_type: PropTypes.string,
  showTitle: PropTypes.bool,
  filters: PropTypes.array,
  t: PropTypes.func
};

AccountAnalyticsWidget.defaultProps = {
  first: false,
  titlePaddingBottom: null,
  analytics_type: null,
  showTitle: true,
  filters: [],
  t: i18n.t.bind(i18n)
};

export default connect(mapStateToProps, null)(withTranslation()(AccountAnalyticsWidget));
